import React from 'react'
import { useValue } from '@morningtrain/react-resources'
import LineChartWidget from 'widgets/charts/LineChartWidget'
import GuestCountLineChartTooltip from 'widgets/charts/tooltips/GuestCountLineChartTooltip'
import useSelectedDepartmentIds from 'support/hooks/use-selected-department-ids'

export default function GuestCountLineChartLoader () {
  const entries = useValue('entries', [])
  const mode = useValue('meta.time_mode', 'daily')

  const [selctedDepartmentIds] = useSelectedDepartmentIds()

  const lines = [
    {
      dataKey: 'guestcount',
      stroke: '#616DE1'
    },
    {
      dataKey: 'guestcount_ly',
      stroke: '#E5483F'
    }
  ]

  if (selctedDepartmentIds.length > 1) {
    lines.unshift({
      dataKey: 'guestcount_production',
      stroke: '#6d21af'
    })
  }

  return (
    <LineChartWidget
      data={entries}
      lines={lines}
      tooltipContent={<GuestCountLineChartTooltip />}
      xDataKey='timestamp'
      xTick={{
        type: 'time',
        mode: mode
      }}
      yTick={{
        type: 'number'
      }}
    />
  )
}
